/**
 * Shared per-kind presentation metadata for the activity timeline, used by both
 * the per-client Timeline tab (TimelineTab) and the org-wide Activity page so
 * icons, labels and tones stay consistent across the two surfaces.
 */
import {
  FileText, ScrollText, ShieldCheck, ClipboardList, Gauge, Mic, type LucideIcon,
} from 'lucide-react';
import type { TimelineKind } from '../../../shared/api';

export interface KindMeta {
  label: string;
  icon: LucideIcon;
  /** Tailwind text-colour class — also drives the icon + rail dot. */
  tone: string;
}

export const KIND_META: Record<TimelineKind, KindMeta> = {
  file_note: { label: 'File note', icon: FileText, tone: 'text-ink-soft' },
  advice: { label: 'Advice', icon: ScrollText, tone: 'text-rust' },
  compliance: { label: 'Compliance', icon: ShieldCheck, tone: 'text-forest' },
  intake_fact_find: { label: 'Fact-find', icon: ClipboardList, tone: 'text-brass-deep' },
  intake_risk_profile: { label: 'Risk profile', icon: Gauge, tone: 'text-brass-deep' },
  intake_file_note: { label: 'File-Note.AI', icon: Mic, tone: 'text-brass-deep' },
};

export const TIMELINE_FILTER_OPTIONS: Array<{ value: '' | TimelineKind; label: string }> = [
  { value: '', label: 'All activity' },
  { value: 'file_note', label: 'File notes' },
  { value: 'advice', label: 'Advice' },
  { value: 'compliance', label: 'Compliance' },
  { value: 'intake_fact_find', label: 'Fact-finds' },
  { value: 'intake_risk_profile', label: 'Risk profiles' },
  { value: 'intake_file_note', label: 'File-Note.AI sessions' },
];
